import { Flex} from '@aws-amplify/ui-react';
import '../styles/clientTable.css';

function Table({values}){
  return (
    <Flex
      justifyContent="center"
      id ="dataTable"
    >
      <table>
        <thead>
          <tr>
            <th>Tipo Documento</th>
            <th>Numero Documento</th>
            <th>Nombre Apellidos</th>
            <th>Empresa</th>
            <th>ARL</th>
            <th>EPS</th>
            <th>Fecha Realización Curso SASS</th>
            <th>Fecha Vencimiento Curso SASS</th>
            <th>Estado Curso SASS</th>
            <th>Planta</th>
          </tr>
        </thead>
        <tbody>
          {values.map((value) => (
            <tr key={value.id}>
              <td className='clientData'>{value.Type}</td>
              <td className='clientData'>{value.id}</td>
              <td className='clientData'>{value.Nombre}</td>
              <td className='clientData'>{value.Empresa}</td>
              <td className='clientData'>{value.ARL}</td>
              <td className='clientData'>{value.EPS}</td>
              <td className='clientData'>{value.FechaRealizacion}</td>
              <td className='clientData'>{value.FechaVencimiento}</td>
              <td className='clientData'>{value.EstadoCurso}</td>
              <td className='clientData'>{value.Planta}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Flex>
  );    
}

export default Table;